import { useScroll, useTransform, motion } from 'framer-motion';
import React, { useState } from 'react';
import type { FC } from 'react';

import pageUrls from 'constants/pagesUrls';

import ALink from 'components/basic/ALink';
import ContentContainer from 'components/basic/ContentContainer';
import Icon from 'components/basic/Icon';
import { IconTypes } from 'components/basic/Icon/types';
import DesktopMenu from 'components/complex/NavigationMenu/DesktopMenu';
import MobileMenu from 'components/complex/NavigationMenu/MobileMenu';
import s from 'components/complex/NavigationMenu/NavigationMenu.module.scss';
import type { NavigationTypes } from 'components/complex/NavigationMenu/types';
import { getRgbColor } from 'components/complex/NavigationMenu/utils';

const NavigationMenu: FC<NavigationTypes> = ({
  isDark,
  color,
  setShowForm,
  buttonClassName,
}) => {
  const { scrollY } = useScroll();
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [start, end] = [50, 1300];
  const opacity = useTransform(scrollY, [0, start, end], [0, 0, 0.9]);
  const backgroundColor = useTransform(opacity, o =>
    getRgbColor(color, o, isDark),
  );
  const backdropFilter = useTransform(opacity, o =>
    o > 0 ? 'blur(8px)' : 'none',
  );

  return (
    <motion.div
      className={s.headerMenu}
      style={{
        backgroundColor,
        backdropFilter: isOpenMenu ? 'none' : backdropFilter,
      }}
    >
      <ContentContainer className={s.wrapper}>
        <ALink href={pageUrls.home} className={s.link}>
          <Icon icon={IconTypes.logo} className={s.mainLogo} />
        </ALink>
        <DesktopMenu
          buttonClassName={buttonClassName}
          color={color}
          isDark={isDark}
          setShowForm={setShowForm}
        />
        <MobileMenu
          isOpenMenu={isOpenMenu}
          setIsOpenMenu={setIsOpenMenu}
          color={color}
          setShowForm={setShowForm}
        />
      </ContentContainer>
    </motion.div>
  );
};

export default NavigationMenu;
